<template>
  <div @click="openfile" class="imageupload upload-select-picture-card">
    <input
        hidden
        type="file"
        accept="image/*"
        ref="imageupload"
        v-on:change="upload($event.target.files)"
    />
    <div  v-if="loading" class="imageupload">
      <v-progress-circular
          :size="50"
          :width="2"
          class="imgupload"
          color="red"
          indeterminate
      ></v-progress-circular>
      <div class="upload-text">
        Uploading....
      </div>
    </div>
    <div class="imageupload">
      <img v-if="!loading && done"
           class="imgupload"
           :src="src"
           alt="image"
           width="100"
           height="100"
      />
      <v-icon v-if="!done && !loading">backup</v-icon>
      <div v-if="!done && !loading" class="upload-text">
        {{label}}
      </div>
    </div>
  </div>
</template>

<script>
import { serviceUpload } from '@/services/serviceupload'

export default {
  name: 'NPWPUpload',
  props: ['label', 'value'],
  data: () => ({
    loading: false,
    done: false,
    src: ''
  }),
  computed: {
    imgserc: {
      get () {
        return this.value
      },
      set (val) {
        this.src = val
      }
    }
  },
  methods: {
    showPreview: async function (file) {
      console.log(file)
      var reader = new FileReader()
      if (file) {
        this.loading = true
        serviceUpload.uploadimage(file)
          .then(response => {
            this.loading = false
            console.log(response.imageurl)
            this.done = true
            window.getApp.$emit('DONE_UPLOAD_NPWP', response.imageurl)
          })
          .catch(error => {
            this.loading = false
            this.done = false
            console.log('err upload')
            console.log(error)
          })
        reader.readAsDataURL(file)
        this.imgserc = await new Promise((resolve) => {
          reader.onload = function () {
            resolve(reader.result)
          }
        })
      }
    },
    openfile () {
      // document.getElementsByName('imageupload')[0].click()
      this.$refs.imageupload.click()
    },
    upload: function (files) {
      this.showPreview(files[0])
    }
  }
}
</script>

<style scoped>
.upload-select-picture-card .upload-text {
  margin-top: 8px;
  color: #666;
}
.upload-select-picture-card {
  display: table;
  width: 90%;
  height: 125px;
  margin-right: 8px;
  margin-left: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color .3s ease;
}
.imageupload {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  margin: 8px;
  padding: 8px;
  color: rgba(0,0,0,.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  outline: 0;
}
.upload-select-picture-card > .imageupload {
  display: table-cell;
  width: 100%;
  height: 100%;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}
</style>
